<template>
  <div id="top">
    <b-card class="custom-card">

    <div class="text-center">
      <p>{{$t('pr_post_limit4')}} {{getUserProfile.postsLimit}} {{$t('pr_post_limit5')}}</p>
    </div>
    <b-row>
      <b-col>
        <circle-button :iAmArtist="true" :selectButton="isLookingJob" @click="isLookingJob=true"/>
      </b-col>
      <b-col>
        <circle-button :iAmArtist="false" :selectButton="!isLookingJob" @click="isLookingJob=false"/>
      </b-col>
    </b-row>
    <select-skills @change-sected-skills="selectedSkills=$event" :data="{selectedSkills: selectedSkills}"/>
    <div class="row">
      <div class="col-lg-9 col-xl-10">
        <textarea v-model="text" :placeholder="$t('enterText')" class="form-control" rows="5" style="margin-bottom: 10px;" maxlength="1000"></textarea>
      </div>
      <div class="col-lg-3 col-xl-2">             
        <div v-if="selectedPhoto" class="text-center image-select">
          <button type="button" aria-label="Close" class="close" :title="$t('deleteImage')" @click="deleteImage()">×</button>
          <img v-if="selectedPhoto" class="attached-img" :src="selectedPhoto"/>
        </div>
        <div class="image-select" v-if="!selectedPhoto">
          <div @click="selectImage" class="image-select-view trigger">
            <span class="image-text">{{$t('pr_drag_drop_file')}}</span>
          </div>
          <input type="file" style="display: none;" ref="fileInput" accept="image/jpeg,image/png,image/gif,image/bmp" @change="onUploadChange($event)"/>
        </div>
      </div>
    </div>
    <div class="row" style="margin-bottom: 10px;">
      <div class="col-md-4 col-xs-12">
        <div class="form-group has-label">
            <label>
                {{$t('from')}}
            </label>
            <datepicker class="datepicker-post" :clear-button="true" :format="dateFormatter" :language="calendarLng()" v-model="date_start" :placeholder="$t('pr_placeholder_date')" name="dateBirthday"></datepicker>
        </div>
      </div>
      <div class="col-md-4 col-xs-12">
        <div class="form-group has-label">
            <label>
                {{$t('to')}}
            </label>
            <datepicker class="datepicker-post" :clear-button="true" :format="dateFormatter" :language="calendarLng()" v-model="date_end" :placeholder="$t('pr_placeholder_date')" name="dateBirthday"></datepicker>
        </div>
      </div>
      <div class="col-md-4 col-xs-12">
        <div class="form-group has-label">
            <label>
                {{$t('enterCityInput')}}
            </label>
            <input ref="autocomplete" name="autocomplete" class="form-control" :placeholder="$t('enterCityInput')" @change="clearGooglePlace"/>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <button v-if="!isSendingPost" class="btn btn-outline-danger btn-filter btn-filter-m" 
        @click="sendPost" :disabled="!text.length">{{$t('save')}}</button>
      </div>
    </div>
    <sync-loader v-if="isSendingPost" class="text-center" color="red"></sync-loader>
    <div v-if="posts.length" class="post-container">
      <gallery :input="posts" :index="indexImg" @close="indexImg = null"></gallery>
      <b-row class="card card-post" v-for="(post, postIndex) in posts" :key="postIndex" :id="'post'+postIndex">
        <div class="col-md-12">
          <div class="control-btn" v-if="post.usersId===getUserProfile.id">
            <b-button size="sm" variant="outline-danger" :title="$t('edit')" @click="editPost(post)"><i class="fa fa-edit"></i></b-button>
            <b-button size="sm" variant="outline-danger" :title="$t('delete')" @click="deletePost(post)"><i class="fa fa-trash"></i></b-button>
          </div>
        </div>
        <router-link :to="{name: 'profile', params: {id: post.users.id}}">
          <div style="width: 100%;">
            <img :src="post.users.avatar" class="image-avatar"/>{{post.users.firstName}} {{post.users.lastName}}
          </div>
        </router-link>
        <div class="col-md-12 disable-col-padding status-post">
          <div v-if="post.participantType === 1"><i class="fa fa-check fa-post"></i>{{$t('availableForContract')}}</div>
          <div v-if="post.participantType !== 1"><i class="fa fa-search fa-post"></i> {{$t('lookingFor')}}</div>
        </div>
        <div class="col-md-12 disable-col-padding">
          <div v-if="post.artistTypesList.length" class="skills-post">
            <p v-for="(skill, index) in post.artistTypesList" :key="index">{{getSkillString(skill)}}</p>
          </div>
          <div class="row">
            <div class="col-md-10" v-if="post.href">
              <div v-for="(text,index) in post.localeTextsList" :key="index" class="message-post">
                {{text.text}}
              </div>
            </div>
            <div class="col-md-12" v-if="!post.href">
              <div v-for="(text,index) in post.localeTextsList" :key="index" class="message-post">
                {{text.text}}
              </div>
            </div>
            <div class="col-md-2 disable-col-padding-l enable-col-padding-m" v-if="post.href">
              <div class="image post-image" v-if="post.href" 
                @click="indexImg = postIndex" 
                :style="{ backgroundImage: 'url(' + post.href + ')'}">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-8" v-if="post.date_start">
              <div class="date-post">
                <i class="fa fa-calendar-o fa-post"></i> {{onlyDate(post.date_start)}}{{post.date_end ? ` - ${onlyDate(post.date_end)}` : ''}}
              </div>
            </div>
            <div class="col-md-6 col-8" v-if="!post.date_start"></div>
            <div class="col-md-6 col-4">
              <div class="location-post date text-right">
                {{$t('created')}} {{dateFormatter(post.created)}}
              </div>
            </div>
            <div class="col-md-12" v-if="post.googlePlace">
              <div class="location-post">
                <i class="fa fa-map-marker fa-post"></i> {{post.googlePlaceLocales && post.googlePlaceLocales[currentLng] && post.googlePlaceLocales[currentLng].formatted_address}}
              </div>
            </div>
          </div>
        </div>
      </b-row>
      <b-pagination v-if="posts.maxPage>1" v-model="posts.currentPage" :total-rows="posts.allPostsCount" :per-page="posts.countPerPage" size="md" align="center" @input="setPage"/>
    </div>
    </b-card>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import CircleButton from './CircleButton'
  import SelectSkills from "./SelectSkills"
  import syncLoader from 'vue-spinner/src/PulseLoader.vue'
  import {en, ru} from 'vuejs-datepicker/dist/locale';
  import datepicker from 'vuejs-datepicker';
  import imageOptimizer from "../modules/imageOptimizer";
  import {POSTS_LOAD_BB,USER_AVATAR_LOAD,POST_SEND,POSTS_LOAD_IMAGE,POST_DELETE} from "../store/actions/userConst";
  import {GOOGLE_GET_PLACE} from "../store/actions/langConst"
  import gallery from 'gallery-vue';
  import swal from 'sweetalert2'

  var moment = require('moment');
  moment().format();

  export default {
    name: 'BB_MyPosts',
    components: { CircleButton, SelectSkills, syncLoader, datepicker, gallery },
    watch: {
      isFullLoad(val) {
        if(val) {
          this.loadPosts();
        }
      }
    },
    computed: {
      ...mapGetters(['getUserProfile','RxLng','RxGoogle','isSendingPost','currentLng','getSkills','getArtistTypes']),
      isFullLoad() {
        return (this.getUserProfile && this.getUserProfile.id && this.getSkills.length && this.getArtistTypes.length) ? true : false;
      },
      postSend() {
        let place;
        if (this.googlePlace && (typeof this.googlePlace.place_id !== 'undefined')) {
          place = this.googlePlace.place_id;
        } else {
          place = null;
        }
        let post = {
          id: this.post.id,
          usersId: this.getUserProfile.id,
          participantType: !this.isLookingJob + 1,
          googlePlace: place,
          localeTextsList: this.post.id ? [{id: this.post.localeTextsList[0].id, locale: this.post.localeTextsList[0].locale, text: this.text}] :
            [{locale: this.currentLng, text: this.text}],
          artistTypesList: this.selectedSkills,
          date_start: this.date_start,
          date_end: this.date_end,
          created: this.post.created,
          // imageId: '',
        }
        // for(let key in post) {
        //   if(!post[key]) delete post[key]
        // }
        return post
      },
    },
    mounted() {
      if(this.isFullLoad) this.loadPosts();
      this.RxLngPointer = this.RxLng.subscribe(()=> {
        // this.updateGooglePlace();
      });
      this.RxGooglePointer = this.RxGoogle.subscribe(gPlace=>{
        if(gPlace) {
          let autocomplete = new gPlace.Autocomplete(this.$refs.autocomplete, {types: ['(cities)']})
          autocomplete.addListener('place_changed', ()=>{
            this.googlePlace = autocomplete.getPlace()
          })
          // let autocompleteFilters = new gPlace.Autocomplete(this.$refs.autocompleteFilters, {types: ['(cities)']})
          // autocompleteFilters.addListener('place_changed', ()=>{
          //   this.filters.googlePlace = autocompleteFilters.getPlace()
          // })
        }
      });
    },
    data() {
      return {
        googlePlace: null,
        cacheAvatars: [],
        cacheImage: [],
        indexImg:null,
        post: {},
        isLookingJob: true,
        selectedSkills: [],
        posts: [],
        text: '',
        selectedPhoto: null,
        postImageObject: null,
        date_start: null,
        date_end: null,
        toast: swal.mixin({
                toast: true,
                position: 'bottom-start',
                customClass: 'sweet-modal',
                showConfirmButton: false,
                timer: 5000
        }),
      }
    },
    methods: {
      ...mapActions([POSTS_LOAD_BB,USER_AVATAR_LOAD,GOOGLE_GET_PLACE,POST_SEND,POSTS_LOAD_IMAGE,POST_DELETE]),
      test() {
        console.log(this.isSendingPost);
      },
      clearPostFields() {
        this.post = {}
        this.selectedSkills = []
        this.text = ''
        this.date_start = null
        this.date_end = null
        this.googlePlace = null
        this.$refs.autocomplete.value = ''
        this.postImageObject = null;
        this.selectedPhoto = null;
      },
      deletePost(post) {
        swal({
          title: this.$t('areYouSure'),
          text: this.$t('text29'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: this.$t('yesDeleteIt'),
          cancelButtonColor: '#d33',
          cancelButtonText: this.$t('cancel')
        }).then((result) => {
          if (result.value) {
            this.POST_DELETE(post.id)
              .then(()=>{
                this.loadPosts()
                swal(
                  this.$t('deleted'),
                  this.$t('text30'),
                  'success'
                )
              })
              .catch(err=>console.log(err))
          }
        })
      },
      editPost(post) {
        this.$refs.autocomplete.value = '';
        if(post.googlePlace) {
          this.GOOGLE_GET_PLACE({place_id: post.googlePlace, language: this.currentLng})
            .then(place=>{
              this.googlePlace = place
              this.$refs.autocomplete.value = place.formatted_address
            })
            .catch(err=>console.log(err))
        }
        this.post = post
        this.isLookingJob = post.participantType === 1
        this.text = post.localeTextsList[0].text
        this.selectedSkills = post.artistTypesList
        this.date_start = post.date_start ? (new Date(post.date_start)).toISOString().split('T')[0] : null
        this.date_end = post.date_end ? (new Date(post.date_end)).toISOString().split('T')[0] : null
        // this.showCollapse = true
        this.$scrollTo('#top', 1000, { container: '#scroll' })
        // preload image to component
        this.selectedPhoto = this.post.href;
      },
      onlyDate(date) {
        let buf = new Date(date)
        return buf.toLocaleString('ru',{day: 'numeric', month: 'numeric', year: 'numeric'})
      },
      getSkillString(skill) {
        let aType = this.getArtistTypes.find(t=>t.id===skill.artistTypeId)
        if(aType) {
          let aCat = aType.categories.find(c=>c.name_en===skill.categories)
          if(aCat) {
            let aSkill = this.getSkills.find(s=>s.code===skill.skill)
            if(aSkill) {
              return `${aType['type_'+this.currentLng]} -> ${aCat['name_'+this.currentLng]} -> ${aSkill['skill_'+this.currentLng]}`
            } else {
              console.log(`Ненайден skill артиста с code=${skill.skill}`)
            }
          } else {
            console.log(`Ненайдена категория артиста с ID=${skill.artistTypeId} name_en=${skill.categories}`)
          }
        } else {
          console.log(`Ненайден тип артиста с ID=${skill.artistTypeId}`)
        }
        return 'Error!'
      },
      loadPosts() {
        let where = {and: [{usersId: {eq: this.getUserProfile.id}}]};
        this.POSTS_LOAD_BB({where: where})
          .then(res=>{
            // this.sendRequestPosts = true;
            this.posts = res.posts;
            this.$scrollTo('#element', 1000, { container: '#scroll' })
            this.updateAvatarCache();
            this.updateGooglePlace();
          })
          .catch(err=>console.log(err))
      },
      sendPost() {
        let postObject;
        let formData = new FormData();
        let image = {};
        if (this.postImageObject) {
          imageOptimizer(this.postImageObject, 1920, 0.6, (blob) => {
            if (!blob) {
              this.toast.fire({
                  title: '<i class="fa fa-times fa-2x"></i>' + this.$t('up_err_filetype')
              });
              return;
            }
            formData.append('file', blob, blob.name);
            postObject = Object.assign(this.postSend, {image: true});
            image = formData;
            this.sendPostFinale({ post: postObject, image: image});
          });
        } else {
          if (this.selectedPhoto) {
            postObject = Object.assign(this.postSend, {image: false, deleteImage: false});
          } else {
            postObject = Object.assign(this.postSend, {image: false, deleteImage: true});
          }
          this.sendPostFinale({ post: postObject, image: image});
        }
      },
      sendPostFinale(data) {
        // console.log(data);
        // return;
        let index = this.cacheImage.findIndex(c=>c.id===data.post.id);
        if(~index) { this.cacheImage.splice(index,1) }
        this.POST_SEND(data)
          .then(res=>{
            if(res.id) {
              this.loadPosts()
              this.$scrollTo('#top', 1000, { container: '#scroll' })
            } else {
              this.loadPosts()
            }
            // this.showCollapse = false
            this.clearPostFields()
            this.updateGooglePlace()
          })
          .catch((err)=> {
            console.log(err);
            const code = this.$ObjValidate(() => err.response.data.error.code) ? err.response.data.error.code : '';
            if (code === 'UPLOAD_POST_LIMIT') {
                this.toast.fire({
                        title: '<i class="fa fa-exclamation fa-2x"></i>' + this.$t('pr_post_limit', {limit: this.getUserProfile.postsLimit})
                    });
                // this.showCollapse = false;
                this.clearPostFields();
            } else {
                console.log(err);
                this.toast.fire({
                    title: '<i class="fa fa-times fa-2x"></i>' + this.$t('p_post_not_uploaded')
                });
            }
          });
      },
      updateGooglePlace() {
        this.posts.forEach(post=>{
          if(post.googlePlace) {
            post.googlePlaceLocales = post.googlePlaceLocales || {}
            if(!post.googlePlaceLocales[this.currentLng]) {
              this.GOOGLE_GET_PLACE({place_id: post.googlePlace, language: this.currentLng, fields: ['formatted_address']})
                .then(place=>{
                  post.googlePlaceLocales[this.currentLng]=place
                  this.posts.push({})
                  this.posts.splice(this.posts.length-1,1)
                })
                .catch(err=>console.log(err))
            }
          }
        })
      },
      updateAvatarCache() {
        this.posts.forEach(element => {
          if(element.users) {
            if(!~this.cacheAvatars.findIndex(c=>c.id===element.usersId)) {
              this.cacheAvatars.push({id: element.usersId})
            }
          } else {
            element.users = {}
            element.users.firstName = 'Unknow'
            element.users.lastName = 'User'
          }
          if(element.imageId && !~this.cacheImage.findIndex(c=>c.id===element.id)) {
            this.cacheImage.push({id: element.id, imageId: element.imageId})
          }
        })
        this.cacheAvatars.forEach(c => {
          if(!c.avatar) {
            this.USER_AVATAR_LOAD(c)
              .then((img)=>{
                c.avatar = img
                this.posts.filter(p=>p.usersId===c.id).forEach(p1=>p1.users.avatar=c.avatar)
                this.posts.push({})
                this.posts.splice(this.posts.length-1,1)
              })
              .catch((err)=>console.log(err))
          } else {
            this.posts.filter(p=>p.usersId===c.id).forEach(p1=>p1.users.avatar=c.avatar)
            this.posts.push({})
            this.posts.splice(this.posts.length-1,1)
          }
        })
        this.cacheImage.forEach(c => {
          if(!c.href) {
            this.POSTS_LOAD_IMAGE(c.imageId)
              .then((img)=>{
                c.href = img
                this.posts.filter(p=>p.id===c.id).forEach(p1=>p1.href=c.href)
                this.posts.push({})
                this.posts.splice(this.posts.length-1,1)
              })
              .catch((err)=>console.log(err))
          } else {
            this.posts.filter(p=>p.id===c.id).forEach(p1=>p1.href=c.href)
            this.posts.push({})
            this.posts.splice(this.posts.length-1,1)
          }
        })
      },
      clearGooglePlace(evn) {
        if(evn.target.attributes.name.nodeValue === 'autocompleteFilters') {
          if(!evn.target.value.length) this.filters.googlePlace = null
        } else {
          if(!evn.target.value.length) this.googlePlace = null
        }
      },
      calendarLng() {
        if (this.currentLng === 'ru') {
          return ru;
        } else if (this.currentLng === 'en') {
          return en;
        }
      },
      selectImage() {
        this.$refs.fileInput.click();
      },
      onUploadChange(evt) {
        let reader = new FileReader();
        try {
          reader.onload = (e) => {
            this.selectedPhoto = e.target.result;
            this.postImageObject = evt.target.files[0];
          }
          reader.readAsDataURL(evt.target.files[0]);
        } catch (error) {
          console.log('FileReader API not supported: use the <form>');
          this.toast.fire({
            title: '<i class="fa fa-times fa-2x"></i>' + error.message
          });
        }
      },
      deleteImage() {
        this.selectedPhoto = null;
        this.postImageObject = null;
      },
      dateFormatter(date) {
        return moment(date).format('DD.MM.YYYY');
      },
    },
    beforeDestroy() {
      this.RxLngPointer.unsubscribe()
      this.RxGooglePointer.unsubscribe()
    },
  }
</script>

<style lang="scss" scoped>
  .card label {
    font-size: 14px;
    margin-bottom: 5px;
    text-transform: uppercase;
    font-weight: 400;
    color: #828080;
  }
  label {
    display: inline-block;
  }
  .image-avatar {
      width: 50px;
      height: 50px;
      border-radius: 100px;
      border: 1px solid #eee;
      margin-right: 10px;
  }
  .card-post {
    padding: 20px;
    margin-bottom: 20px;
    color: #565656 !important;
  }
  .card-post .control-btn {
    position: absolute;
    right: 0px;
  }
  .card-post .btn-outline-danger {
    margin-right: 3px;
  }
  .card-post .status-post {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .card-post .status-post .fa {
    margin-right: 5px;
  }
  .card-post .skills-post { 
    background-color: white; 
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
    padding: 10px;
    margin-top: 10px;
    max-height: 100px; 
    overflow-y: auto;
  }
  .card-post .skills-post::-webkit-scrollbar {
      width: 8px
  }
  .card-post .skills-post p { 
    margin-bottom: 5px;
  }
  .card-post .message-post {
    background-color: white; 
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
    padding: 10px;
    margin-top: 10px;
    height: 100px; 
    overflow-y: auto;
  }
  .card-post .date-post,
  .card-post .location-post {
    margin-top: 10px;
  }
  .card-post .fa-map-marker {
    font-size: 20px;
    padding-right: 3px;
  }
  .card-post .fa-post {
    color: #474747 !important;
    padding-right: 5px;
  }
  .btn-post {
    border-radius: 4px !important;
    margin-right: 15px;
    margin-left: 6px;
    margin-bottom: 10px;
  }
  .btns-upload {
      border-radius: 100px !important;
      padding-left: 20px !important;
      padding-right: 20px !important;
      padding-top: 3px !important;
      font-weight: 500 !important;
      height: 33px !important;
  }
  .btn-outline-danger {
      min-width: 32px;
  }
  .image {
      float: left;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      border: 1px solid #ebebeb;
      margin-top: 10px;
  }
  .post-image {
      width: 100% !important;
      height: 100px;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s;
  }
  .row-gallery {
          border: 1px solid rgba(0, 0, 0, 0.125);
          /* border-radius: 0.25rem; */
          min-height: 212px;
          background-image: url('../assets/img/no-media.png');
          background-size: 180px;
          background-repeat: no-repeat;
          background-position-x: 15px;
          background-position-y: 15px;
  }
  // #elementEditPost {
  //   padding-top: 10px;
  // }
  input[name='autocomplete'] {
    margin-bottom: 20px;
  }
  .post-container {
    padding: 20px;
  }
  .message-post::-webkit-scrollbar {
    width: 7px !important;
  }
  .post-message {
    float: right;
    padding-right: 10px;
    color: #565656;
  }
  .no-find-result {
    text-align: center;
    color: #565656;
    padding-top: 50px;
    padding-bottom: 50px;
  }
  #collapse1 {
    margin-bottom: 10%;
  }

  .image-select-view {
    width: 95%;
    height: 135px;
    background-color: grey;
    cursor: pointer;
    text-align: center;
    display: block;
    /* display: table-cell; */
    /* vertical-align: middle; */
    padding: 8px;
    border-radius: 0.25rem;
    color: #efefef;
    text-shadow: 1px 1px 1px #000000d6;
  }
  .image-select {
    margin-top: 0px;
    width: 95%;
  }
  .attached-img {
    width: 95%;
    height: 135px;
    object-fit: cover;
    cursor: pointer;
    border-radius: 0.25rem;
  }
  .image-text {
    text-overflow: ellipsis;
    display: inline-block;
    overflow: hidden;
    width: 100%;
    text-align: center;
    font-size: 14px;
    /* white-space: nowrap; */
    position: relative;
    top: 20%;
  }
  .image-select .close {
    display: inline-block;
    position: absolute;
    right: 5px;
    top: -10px;
    color: red;
    font-weight: bold;
  }
  .form-group input::placeholder {
      color: rgb(206, 212, 218) !important;
  }
  .form-radio span {
      font-size: 14px !important;
      padding-left: 3px;
      position: relative;
      top: -3px;
      /* margin-bottom: 5px; */
  }
  .form-group label.form-radio {
      font-size: 22px;
      margin-bottom: 5px;
      text-transform: uppercase;
      font-weight: 400;
      color: #565656;
      line-height: 1;
      margin-top: 10px;
  }
  input[type="checkbox"]:disabled ~ label {
      color: #a9abad !important;
      cursor: not-allowed;
  }
  .filter-label {
    color: #565656;
    display: inline-block;
  }
  .filter-label.second {
    margin-bottom: 10px;
  }
  .filter-label.third {
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .form-control.filter {
      background-color: #fff;
      border-radius: 4px;
      font-size: 14px;
      color: #565656;
      padding: 8px 12px;
      height: 40px;
      -webkit-box-shadow: none;
      box-shadow: none;
  }
  input.form-control.filter::placeholder {
      color: #adadad !important;
  }
  .form-control.filter:disabled {
    cursor: not-allowed;
    background-color: #e9ecef;
    color: #bdbdbd !important;
  }
  @media only screen and (max-width: 768px) {
    .btn-outline-danger {
      display: block;
      margin-top: 5px;
      min-width: 32px;
    }
    .card-post .control-btn {
      position: absolute;
      right: -10px;
      top: -12px;
    }
    .btn-wd {
      min-width: 10px !important;
      font-size: 0.68rem !important;
    }
    .btn-post {
      margin-right: 5px;
    }
    .card-post .message-post {
      margin-top: 10px;
      height: auto; 
      overflow-y: hidden;
    }
    // #elementEditPost {
    //   padding-top: 0px;
    // }
    .post-container {
      padding: 5px;
    }

    .image-select .close {
      right: 10px;
    }
    .image-select {
      width: 100%;
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .image-select-view {
      width: 100%;
    }
    .image-select img {
      width: 93% !important;
      float: left;
      margin-bottom: 10px;
    }
    .image-select-view {
      padding-left: 20px;
      padding-right: 20px;
    }
    .btn-filter-m {
      margin-bottom: 40px;
    }
    .margin15 {
      margin-top: 15px;
    }
  }
  .btn.btn-outline-danger:disabled {
    // border-color: #ced4da;
    // background-color: #e9ecef !important;
    // color: #bdbdbd;
    cursor: not-allowed !important;
    opacity: 1;
  }
  .card.custom-card {
    border: none !important;
  }
</style>